import React, { useMemo, useState } from "react";
import Navbar from "../Navbar/Navbar";
import Bredcom from "../Bredcom/Bredcom";
import Footer from "../Footer/Footer";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const documents = [
  {
    title: "Osnovne studije AKREDITACIJA",
    file: "1. Osnovne studije AKREDITACIJA.pdf",
  },
  { title: "Osnovne studije LICENCA", file: "2. Osnovne studije LICENCA.pdf" },
  {
    title: "Osnovne studije REAKREDITACIJA",
    file: "3. Osnovne studije REAKREDITACIJA.pdf",
  },
  {
    title: "Specijalisticke studije JAVNI SEKTOR akreditacija",
    file: "4. Specijalisticke studije JAVNI SEKTOR akreditacija.pdf",
  },
  {
    title: "Specijalisticke studije PROFITNI SEKTOR akreditacija",
    file: "5. Specijalisticke studije PROFITNI SEKTOR akreditacija.pdf",
  },
  {
    title: "Specijalisticke studije - dopuna licence",
    file: "6. Specijalisticke studije - dopuna licence.pdf",
  },
  {
    title: "Magistarske studija - akreditacija",
    file: "7. Magistarske studija - akreditacija.pdf",
  },
  {
    title: "Magistarske studije - dopuna licence",
    file: "8. Magistarske studije - dopuna licence.pdf",
  },
  {
    title: "Rjesenje o izmjeni broja studenata na specijalistickim studijama",
    file: "9. Rjesenje o izmjeni broja studenata na specijalistickim studijama.pdf",
  },
  {
    title: "Rjesenje o licenciranju Univerzitet ADRIATIK",
    file: "10. Rjesenje o licenciranju Univerzitet ADRIATIK.pdf",
  },
  {
    title: "Licenca za obavljanje naucno-istrazivacke djelatnosti",
    file: "11. Licenca za obavljanje naucno-istrazivacke djelatnosti.pdf",
  },
  {
    title: "PRAVO Osnovne studije AKREDITACIJA",
    file: "12. PRAVO Osnovne studije AKREDITACIJA.pdf",
  },
  {
    title: "PRAVO Postdiplomske master studije AKREDITACIJA",
    file: "13. PRAVO Postdiplomske master studije AKREDITACIJA.pdf",
  },
  {
    title: "PRAVO Osnovne i Postdiplomske LICENCA",
    file: "14. PRAVO Osnovne i Postdiplomske LICENCA.pdf",
  },
  {
    title: "Akreditacija - osnovne akademske studije Menadzment",
    file: "15. Akreditacija - osnovne akademske studije Menadzment.pdf",
  },
  {
    title:
      "Akreditacija - osnovne akademske studije Racunovodstvo, finansije i bankarstvo",
    file: "16. Akreditacija - osnovne akademske studije Racunovodstvo, finansije i bankarstvo.pdf",
  },
  {
    title:
      "Akreditacija - postdiplomske master akademske studije Ekonomija javnog sektora",
    file: "17. Akreditacija - postdiplomske master akademske studije Ekonomija javnog sektora.pdf",
  },
  {
    title:
      "Akreditacija - postdiplomske master akademske studije Poslovna ekonomija",
    file: "18. Akreditacija - postdiplomske master akademske studije Poslovna ekonomija.pdf",
  },
  {
    title: "Dopuna licence za osnovne i postdiplomske master studije",
    file: "19. Dopuna licence za osnovne i postdiplomske master studije.pdf",
  },
  {
    title: "Licenca za obavljanje naucno-istrazivacke djelatnosti",
    file: "20. Licenca za obavljanje naucno-istrazivacke djelatnosti.pdf",
  },
  {
    title: "Reakreditacija ustanove",
    file: "21-1. Reakreditacija ustanove.pdf",
  },
  {
    title: "Sertifikat o reakreditaciji",
    file: "21-2. Sertifikat o reakreditaciji.pdf",
  },
];

// Sidebar iz Erasmus stranice (isti markup)
function Sidebar() {
  const [t] = useTranslation();

  return (
    <div className="col-md-4 pt-10">
      <aside className="sidebar-widget">
        <section
          id="custom_html-5"
          className="widget_text widget widget_custom_html"
        >
          <h2 className="widget-title">{t("sidebar.follow")}</h2>
          <div className="textwidget custom-html-widget">
            <div className="widget-social">
              <a
                href="https://www.facebook.com/fpebar.me"
                target="_blank"
                rel="noopener noreferrer"
                title="Facebook"
              >
                <i className="fab fa-facebook-f" />
              </a>
              <a
                href="https://www.instagram.com/fpepbar/"
                target="_blank"
                rel="noopener noreferrer"
                title="Instagram"
              >
                <i className="fab fa-instagram" />
              </a>
              <a
                href="https://www.youtube.com/@fpepbar"
                target="_blank"
                rel="noopener noreferrer"
                title="YouTube"
              >
                <i className="fab fa-youtube" />
              </a>
              <a
                href="https://www.tiktok.com/@fpepbar"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Follow us on Tiktok"
                title="Tiktok"
              >
                <i className="fab fa-tiktok" />
              </a>
              <a
                href="https://www.linkedin.com/school/fpepbar/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Follow us on LinkedIn"
                title="LinkedIn"
              >
                <i className="fab fa-linkedin-in" />
              </a>
            </div>
          </div>
        </section>

        <section id="categories-1" className="widget widget_categories">
          <h2 className="widget-title">{t("sidebar.useful")}</h2>
          <ul>
            <li className="cat-item cat-item-16">
              <Link to="/o-fpep">{t("about.fpep")}</Link>
            </li>
            <li className="cat-item cat-item-23">
              <Link to="/akreditacija-fpep">{t("admission.Akreditacija")}</Link>
            </li>
            <li className="cat-item cat-item-18">
              <Link to="/upis">{t("upis.title")}</Link>
            </li>
            <li className="cat-item cat-item-22">
              <Link to="/cijene-studija">{t("admission.Skolarina")}</Link>
            </li>
            <li className="cat-item cat-item-22">
              <Link to="/erasmus">{t("saradnja.erasmus")}</Link>
            </li>
            <li className="cat-item cat-item-22">
              <Link to="/projekti">{t("saradnja.projekti")}</Link>
            </li>
            <li className="cat-item cat-item-22">
              <Link to="/dom-studenata">{t("studenti.dom")}</Link>
            </li>
            <li className="cat-item cat-item-22">
              <Link to="/galerija">{t("navbar.Gallery")}</Link>
            </li>
            <li className="cat-item cat-item-22">
              <Link to="/novosti">{t("navbar.News")}</Link>
            </li>
          </ul>
        </section>

        <section id="recent-posts-4" className="widget widget_recent_entries">
          <h2 className="widget-title">{t("sidebar.study")}</h2>
          <ul>
            <li>
              <span className="post-date">
                <strong>{t("programs.osnovne")}</strong> <br />
              </span>
              <Link to="/racunovodstvo-finansije-i-bankarstvo">
                {t("osnovne.rfb")}
                <br />
              </Link>
            </li>
            <li>
              <Link to="/menadzment">
                {t("osnovne.menadzment")}
                <br />
              </Link>
            </li>
            <li>
              <Link to="/pravo-osnovne">
                {t("osnovne.pravo")}
                <br />
              </Link>
            </li>

            <li>
              <span className="post-date">
                <strong>{t("programs.master")}</strong> <br />
              </span>
              <Link to="/poslovna-ekonomija">
                {t("master.poslovnaEkonomija")}
                <br />
              </Link>
            </li>
            <li>
              <Link to="/ekonomija-javnog-sektora">
                {t("master.ekonomijaJavnogSektora")}
                <br />
              </Link>
            </li>
            <li>
              <Link to="/pravo-master">
                {t("master.pravo")}
                <br />
              </Link>
            </li>

            <li>
              <span className="post-date">
                <strong>{t("programs.specijalisticke")}</strong> <br />
              </span>
              <Link to="/menadzment-javnog-sektora-specijalisticke">
                {t("specijalisticke.mjs")}
                <br />
              </Link>
            </li>
            <li>
              <Link to="/menadzment-profitnog-sektora-specijalisticke">
                {t("specijalisticke.mps")}
                <br />
              </Link>
            </li>
          </ul>
        </section>
      </aside>
    </div>
  );
}

function getDocType(title) {
  const s = title.toLowerCase();
  if (s.includes("sertifikat") || s.includes("reakreditacija"))
    return "Reakreditacija";
  if (s.includes("dopuna licence")) return "Dopuna licence";
  if (s.includes("licenca") || s.includes("licenciranju")) return "Licenca";
  if (s.includes("rjesenje")) return "Rješenje";
  if (s.includes("akreditacija")) return "Akreditacija";
  return "Dokument";
}

function normalizeText(str) {
  return (str || "").toLowerCase().trim();
}

function DozvoleZaRad() {
  const { i18n } = useTranslation();
  const lang = i18n?.language?.startsWith("en") ? "en" : "me";

  const copy = {
    me: {
      title: "Dozvole za rad i akreditacije (registar dokumenata)",
      lead: "Stranica je namijenjena ustanovama i nadležnim tijelima za brzu provjeru i preuzimanje prateće dokumentacije. Dokumenti su dostupni kao PDF prilozi, sa nazivima fajlova radi lakše provjere.",
      search: "Pretraga po nazivu ili fajlu…",
      filter: "Filtriraj po vrsti",
      all: "Sve",
      tableType: "Vrsta",
      tableTitle: "Naziv dokumenta",
      tableFile: "Fajl",
      tableAction: "Pregled",
      open: "Otvori PDF",
      note: "Napomena: dokumenti se otvaraju u novom tabu.",
    },
    en: {
      title: "Licences & Accreditations (Document Register)",
      lead: "This page is intended for institutions and competent authorities for quick verification and access to supporting documents. Files are provided as PDF attachments with file names shown for easier checking.",
      search: "Search by title or file name…",
      filter: "Filter by type",
      all: "All",
      tableType: "Type",
      tableTitle: "Document title",
      tableFile: "File",
      tableAction: "View",
      open: "Open PDF",
      note: "Note: documents open in a new tab.",
    },
  };

  const [query, setQuery] = useState("");
  const [activeType, setActiveType] = useState("ALL");

  const docs = useMemo(() => {
    return documents
      .map((d) => ({ ...d, type: getDocType(d.title) }))
      .sort((a, b) => a.title.localeCompare(b.title));
  }, []);

  const types = useMemo(() => {
    const set = new Set(docs.map((d) => d.type));
    return ["ALL", ...Array.from(set)];
  }, [docs]);

  const filtered = useMemo(() => {
    const q = normalizeText(query);
    return docs.filter((d) => {
      const matchesType = activeType === "ALL" || d.type === activeType;
      const matchesQuery =
        !q ||
        normalizeText(d.title).includes(q) ||
        normalizeText(d.file).includes(q);
      return matchesType && matchesQuery;
    });
  }, [docs, query, activeType]);

  return (
    <>
      <Navbar />
      <Bredcom title="Početna" subtitle="Dozvole za rad" />

      <div className="docs-page docs-page--registry">
        <div className="container mt-4 pt-60 pb-60">
          <div className="row">
            {/* MAIN */}
            <div className="col-md-8">
              <div className="docs-hero-card">
                <h1 className="docs-title">{copy[lang].title}</h1>
                <p className="docs-lead">{copy[lang].lead}</p>

                <div className="docs-toolbar">
                  <div className="docs-search">
                    <i className="fas fa-search" aria-hidden="true" />
                    <input
                      type="search"
                      value={query}
                      onChange={(e) => setQuery(e.target.value)}
                      placeholder={copy[lang].search}
                      aria-label={copy[lang].search}
                    />
                  </div>

                  <div className="docs-filter">
                    <label className="docs-filter-label">
                      {copy[lang].filter}
                    </label>
                    <select
                      value={activeType}
                      onChange={(e) => setActiveType(e.target.value)}
                    >
                      {types.map((tp) => (
                        <option key={tp} value={tp}>
                          {tp === "ALL" ? copy[lang].all : tp}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="docs-muted">
                  <i className="fas fa-info-circle" aria-hidden="true" />{" "}
                  {copy[lang].note}
                </div>
              </div>

              <div
                className="docs-table-wrap"
                role="region"
                aria-label="Tabela dokumenata"
              >
                <table className="docs-table">
                  <thead>
                    <tr>
                      <th>{copy[lang].tableType}</th>
                      <th>{copy[lang].tableTitle}</th>
                      <th className="docs-col-file">{copy[lang].tableFile}</th>
                      <th className="docs-col-action">
                        {copy[lang].tableAction}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {filtered.map((doc) => (
                      <tr key={doc.file}>
                        <td>
                          <span
                            className={`docs-pill docs-pill--${doc.type
                              .replace(/\s+/g, "-")
                              .toLowerCase()}`}
                          >
                            {doc.type}
                          </span>
                        </td>
                        <td className="docs-td-title">{doc.title}</td>
                        <td className="docs-col-file">
                          <code className="docs-file">{doc.file}</code>
                        </td>
                        <td className="docs-col-action">
                          <a
                            className="docs-action"
                            href={`/Prilozi/${doc.file}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label={`${copy[lang].open}: ${doc.title}`}
                          >
                            <i className="fas fa-file-pdf" aria-hidden="true" />{" "}
                            {copy[lang].open}
                          </a>
                        </td>
                      </tr>
                    ))}
                    {filtered.length === 0 && (
                      <tr>
                        <td colSpan={4} className="docs-empty">
                          Nema rezultata za zadatu pretragu.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>

            <Sidebar />
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
}

export default DozvoleZaRad;
